import SuiteEnum from 'redpoints-model-js-common/enumeration/SuiteEnum';
import OperationsEnum from 'redpoints-model-js/enumeration/OperationsEnum';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import AuthorizationController from 'auth-restapi-connector/controller/AuthorizationController';
import AdDestinationLinkController from 'redpoints-restapi-connector/controller/AdDestinationLinkController';
import AdLinkController from 'redpoints-restapi-connector/controller/AdLinkController';
import ChannelEvidenceTypeController from 'redpoints-restapi-connector/controller/ChannelEvidenceTypeController';
import ChannelLinkDataController from 'redpoints-restapi-connector/controller/ChannelLinkDataController';
import EvidenceController from 'redpoints-restapi-connector/controller/EvidenceController';
import IncidentController from 'redpoints-restapi-connector/controller/IncidentController';
import LinkDataController from 'redpoints-restapi-connector/controller/LinkDataController';
import MonitorRequestController from 'redpoints-restapi-connector/controller/MonitorRequestController';
import AccountController from 'legalentitymapping-restapi-connector/controller/AccountController';

import { LinkService } from 'redpoints-front-common/services';

import {
  CONNECTOR_REQUEST,
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_ACCOUNT_PERMISSIONS,
  INCIDENT_DETAILS_FETCH_CHANNEL_EVIDENCES_TYPES,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_DATA,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_EVIDENCES,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_METADATA,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_MONITOR_DATA,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_RELATED_ADS,
  INCIDENT_DETAILS_FETCH_DESTINATION_LINKS,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_EVIDENCES,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_METADATA,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_MONITOR_DATA,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_RELATED_ADS,
  INCIDENT_DETAILS_FETCH_EVIDENCE_PERMISSIONS,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA,
  INCIDENT_DETAILS_FETCH_LINK_DATA_PERMISSIONS,
  INCIDENT_DETAILS_FETCH_SELLER_PERMISSIONS,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK,
  INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT,
  INCIDENT_DETAILS_SET_CONTENT_LINK_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_EVIDENCE,
  INCIDENT_DETAILS_SET_CONTENT_LINK_IMAGES,
  INCIDENT_DETAILS_SET_CONTENT_LINK_MODIFIED_ACCOUNT,
  INCIDENT_DETAILS_SET_CONTENT_LINK_MULTIMEDIA_FILE,
  INCIDENT_DETAILS_SET_CONTENT_LINK_OFFER_LISTING,
  INCIDENT_DETAILS_SET_CONTENT_LINK_OVERALL_MULTIMEDIA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_PRODUCT_LISTING,
  INCIDENT_DETAILS_SET_CONTENT_LINK_SELLER,
  INCIDENT_DETAILS_SET_CONTENT_LINK_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_EVIDENCE,
  INCIDENT_DETAILS_SET_DETECTION_LINK_IMAGES,
  INCIDENT_DETAILS_SET_DETECTION_LINK_MODIFIED_ACCOUNT,
  INCIDENT_DETAILS_SET_DETECTION_LINK_MULTIMEDIA_FILE,
  INCIDENT_DETAILS_SET_DETECTION_LINK_OFFER_LISTING,
  INCIDENT_DETAILS_SET_DETECTION_LINK_OVERALL_MULTIMEDIA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_PRODUCT_LISTING,
  INCIDENT_DETAILS_SET_DETECTION_LINK_SELLER,
  INCIDENT_DETAILS_SET_DETECTION_LINK_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_ACCOUNT,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_EVIDENCE,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_IMAGE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SELLER,
  INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_FORCE_VALIDATION,
} from './actionTypes';
import { translate } from '../helpers/languageHelper';

export const incidentDetailsClear = () => ({
  type: INCIDENT_DETAILS_CLEAR,
});

export const incidentDetailsSaveContentLink = ({
  contentLinkServiceModel,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_SAVE_CONTENT_LINK,
    connectorMethod: LinkService.save,
    sortedParameters: [contentLinkServiceModel],
    expectedStatus: HttpStatus.OK,
    successfulMessage: translate(
      'reporting.incidentDetails.contentLinkSaveSuccessMessage'
    ),
    successfulDuration: 1,
  },
});

export const incidentDetailsSaveDetectionLink = ({
  detectionLinkServiceModel,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_SAVE_DETECTION_LINK,
    connectorMethod: LinkService.save,
    sortedParameters: [detectionLinkServiceModel],
    expectedStatus: HttpStatus.OK,
    successfulMessage: translate(
      'reporting.incidentDetails.detectionLinkSaveSuccessMessage'
    ),
    successfulDuration: 1,
  },
});

export const incidentDetailsSearchContentLinkAccount = ({
  account: { url: searchUrl, identifier: searchIdentifier },
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT,
    connectorMethod: AccountController.getByUrlAndIdentifier,
    sortedParameters: [searchIdentifier, searchUrl],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND, HttpStatus.CONFLICT],
  },
  payload: { searchIdentifier, searchUrl },
});

export const incidentDetailsSearchDetectionLinkAccount = ({
  account: { url: searchUrl, identifier: searchIdentifier },
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT,
    connectorMethod: AccountController.getByUrlAndIdentifier,
    sortedParameters: [searchIdentifier, searchUrl],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND, HttpStatus.CONFLICT],
  },
  payload: { searchIdentifier, searchUrl },
});

export const incidentDetailsFetchAccountPermissions = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_ACCOUNT_PERMISSIONS,
    connectorMethod: AuthorizationController.hasPermission,
    sortedParameters: ['account', OperationsEnum.UPDATE, SuiteEnum.EM],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
});

export const incidentDetailsFetchChannelEvidencesTypes = ({ channelId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_CHANNEL_EVIDENCES_TYPES,
    connectorMethod: ChannelEvidenceTypeController.list,
    sortedParameters: [channelId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchContentLinkData = ({ contentLinkId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_CONTENT_LINK_DATA,
    connectorMethod: LinkDataController.get,
    sortedParameters: [contentLinkId],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
  },
});

export const incidentDetailsFetchContentLinkMetaData = ({ channelId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_CONTENT_LINK_METADATA,
    connectorMethod: ChannelLinkDataController.list,
    sortedParameters: [channelId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchContentLinkEvidences = ({
  contentLinkId,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_CONTENT_LINK_EVIDENCES,
    connectorMethod: EvidenceController.listByLink,
    sortedParameters: [contentLinkId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchDetectionLinkData = ({ detectionLinkId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_DETECTION_LINK_DATA,
    connectorMethod: LinkDataController.get,
    sortedParameters: [detectionLinkId],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
  },
});

export const incidentDetailsFetchDetectionLinkMetaData = ({ channelId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_DETECTION_LINK_METADATA,
    connectorMethod: ChannelLinkDataController.list,
    sortedParameters: [channelId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchDetectionLinkEvidences = ({
  detectionLinkId,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_DETECTION_LINK_EVIDENCES,
    connectorMethod: EvidenceController.listByLink,
    sortedParameters: [detectionLinkId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchEvidencePermissions = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_EVIDENCE_PERMISSIONS,
    connectorMethod: AuthorizationController.hasPermission,
    sortedParameters: ['evidence', OperationsEnum.CREATE, SuiteEnum.IPR],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
});

export const incidentDetailsFetchIncidentData = ({ assetId, incidentId }) => {
  const full = true;

  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType: INCIDENT_DETAILS_FETCH_INCIDENT_DATA,
      connectorMethod: IncidentController.get,
      sortedParameters: [assetId, incidentId, full],
      expectedStatus: HttpStatus.OK,
      mustShowErrorMessages: false,
    },
  };
};

export const incidentDetailsSetContentLinkEvidence = ({ evidence }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_EVIDENCE,
  payload: { evidence },
});

export const incidentDetailsSetDetectionLinkEvidence = ({ evidence }) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_EVIDENCE,
  payload: { evidence },
});

export const incidentDetailsFetchLinkDataPermissions = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_LINK_DATA_PERMISSIONS,
    connectorMethod: AuthorizationController.hasPermission,
    sortedParameters: ['linkdata', OperationsEnum.UPDATE, SuiteEnum.IPR],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
});

export const incidentDetailsFetchLinkMonitorData = ({
  assetId,
  linkId,
  isContentLink,
}) => {
  const requestType = isContentLink
    ? INCIDENT_DETAILS_FETCH_CONTENT_LINK_MONITOR_DATA
    : INCIDENT_DETAILS_FETCH_DETECTION_LINK_MONITOR_DATA;

  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType,
      connectorMethod: MonitorRequestController.get,
      sortedParameters: [assetId, linkId],
      expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
    },
  };
};

export const incidentDetailsFetchContentLinkRelatedAds = ({
  contentLinkId,
  assetId,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_CONTENT_LINK_RELATED_ADS,
    connectorMethod: AdLinkController.listRelatedAdsByContentLink,
    sortedParameters: [assetId, contentLinkId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchDestinationLinks = ({
  adLinkId,
  assetId,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_DESTINATION_LINKS,
    connectorMethod: AdDestinationLinkController.listDestinationLinks,
    sortedParameters: [assetId, adLinkId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchDetectionLinkRelatedAds = ({
  detectionLinkId,
  assetId,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_DETECTION_LINK_RELATED_ADS,
    connectorMethod: AdLinkController.listRelatedAdsByDetectionLink,
    sortedParameters: [assetId, detectionLinkId],
    expectedStatus: HttpStatus.OK,
  },
});

export const incidentDetailsFetchSellerPermissions = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: INCIDENT_DETAILS_FETCH_SELLER_PERMISSIONS,
    connectorMethod: AuthorizationController.hasPermission,
    sortedParameters: ['seller', OperationsEnum.UPDATE, SuiteEnum.EM],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
});

export const incidentDetailsSetForceValidation = ({
  contentLinkInitialValidationState,
  detectionLinkInitialValidationState,
}) => ({
  type: INCIDENT_DETAILS_SET_FORCE_VALIDATION,
  payload: {
    contentLinkInitialValidationState,
    detectionLinkInitialValidationState,
  },
});

export const incidentDetailsSetContentLinkCommonLinkData = ({
  commonLinkData,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_COMMON_LINK_DATA,
  payload: { commonLinkData },
});

export const incidentDetailsSetContentLinkImages = ({ images }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_IMAGES,
  payload: { images },
});

export const incidentDetailsSetContentLinkMultimediaFile = ({
  multiMediaFile,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_MULTIMEDIA_FILE,
  payload: { multiMediaFile },
});

export const incidentDetailsSetContentLinkOfferListing = ({
  offerListing,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_OFFER_LISTING,
  payload: { offerListing },
});

export const incidentDetailsSetContentLinkOverallMultimedia = ({
  overallMultimedia,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_OVERALL_MULTIMEDIA,
  payload: { overallMultimedia },
});

export const incidentDetailsSetContentLinkPriceList = ({ priceList }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_PRICE_LIST,
  payload: { priceList },
});

export const incidentDetailsSetContentLinkProductListing = ({
  productListing,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_PRODUCT_LISTING,
  payload: { productListing },
});

export const incidentDetailsSetContentLinkModifiedAccount = ({ account }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_MODIFIED_ACCOUNT,
  payload: { account },
});

export const incidentDetailsSetContentLinkSeller = ({ seller }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_SELLER,
  payload: { seller },
});

export const incidentDetailsSetContentLinkSocialMedia = ({ socialMedia }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_SOCIAL_MEDIA_LINK_DATA,
  payload: { socialMedia },
});

export const incidentDetailsSetContentLinkValidationAccount = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationCommonLinkData = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationEvidence = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationLinkImageList = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationLinkPriceList = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationMultimediaFile = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationOfferListing = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationOverallMultimedia = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationProductListing = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationSeller = ({ isValid }) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER,
  payload: { isValid },
});

export const incidentDetailsSetContentLinkValidationSocialMedia = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkModifiedAccount = ({
  account,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_MODIFIED_ACCOUNT,
  payload: { account },
});

export const incidentDetailsSetDetectionLinkCommonLinkData = ({
  commonLinkData,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_COMMON_LINK_DATA,
  payload: { commonLinkData },
});

export const incidentDetailsSetDetectionLinkImages = ({ images }) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_IMAGES,
  payload: { images },
});

export const incidentDetailsSetDetectionLinkMultimediaFile = ({
  multiMediaFile,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_MULTIMEDIA_FILE,
  payload: { multiMediaFile },
});

export const incidentDetailsSetDetectionLinkOfferListing = ({
  offerListing,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_OFFER_LISTING,
  payload: { offerListing },
});

export const incidentDetailsSetDetectionLinkOverallMultimedia = ({
  overallMultimedia,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_OVERALL_MULTIMEDIA,
  payload: { overallMultimedia },
});

export const incidentDetailsSetDetectionLinkPriceList = ({ priceList }) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_PRICE_LIST,
  payload: { priceList },
});

export const incidentDetailsSetDetectionLinkProductListing = ({
  productListing,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_PRODUCT_LISTING,
  payload: { productListing },
});

export const incidentDetailsSetDetectionLinkSeller = ({ seller }) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_SELLER,
  payload: { seller },
});

export const incidentDetailsSetDetectionLinkSocialMedia = ({
  socialMedia,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_SOCIAL_MEDIA_LINK_DATA,
  payload: { socialMedia },
});

export const incidentDetailsSetDetectionLinkValidationAccount = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_ACCOUNT,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationCommonLinkData = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_COMMON_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationEvidence = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_EVIDENCE,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationLinkImageList = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_IMAGE_LIST,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationLinkPriceList = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_LINK_PRICE_LIST,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationMultimediaFile = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationOfferListing = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationOverallMultimedia = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationProductListing = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationSeller = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SELLER,
  payload: { isValid },
});

export const incidentDetailsSetDetectionLinkValidationSocialMedia = ({
  isValid,
}) => ({
  type: INCIDENT_DETAILS_SET_DETECTION_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  payload: { isValid },
});
